import React, { useEffect } from "react";
import { useStoreState } from "pullstate";

import Button from "@/components/Button";
import Filters from "@/components/Filters";
import PodcastTile from "@/components/FeedTiles/PodcastTile";
import SkeletonLoader from "@/components/SkeletonLoader";
import { PodcastEpisodesInterface } from "@/components/PodcastEpisodes/PodcastEpisodes.interface";
import { UIStore } from "@/store/UIStore";
import { apiPath } from "@/helpers/apiPath";
import { defaultPageItems } from "@/helpers/apiPathHelpers";
import { useFilters } from "@/helpers/useFilters";
import { usePagination } from "@/helpers/usePagination";
import { FiltersVariant } from "@/components/Filters/Filters.interface";
import EmptyState from "@/components/EmptyState";

import styles from "./PodcastEpisodes.module.scss";

const sortOptions = [
  {
    name: " Pokaż wszystkie",
    value: "",
  },
  {
    name: " Rozpoczęte",
    value: "started",
  },
  {
    name: " Nierozpoczęte",
    value: "new",
  },
];

export const PodcastEpisodes: React.FC<PodcastEpisodesInterface> = ({
  slug,
  episodes,
}) => {
  const {
    handleSearchChange,
    handleSortChange,
    handleFilterChange,
    sort,
    filter,
    debouncedQuery,
  } = useFilters();

  const {
    mutate,
    elements,
    isLoadingMore,
    isReachingEnd,
    isLoadingInitialData,
    isEmpty,
    loadMore: loadMoreData,
  } = usePagination(episodes.items, defaultPageItems.PODCASTS, (index) =>
    apiPath.EPISODES({
      slug,
      page: index + 1,
      perPage: defaultPageItems.PODCASTS,
      searchQuery: debouncedQuery,
      sort,
      filter,
    })
  );

  const { userLoggedIn } = useStoreState(UIStore, (store) => store);
  const searched = !!debouncedQuery.length;

  const loadMore = () => {
    loadMoreData();
  };

  useEffect(() => {
    mutate();
  }, [userLoggedIn]);

  return (
    <>
      <Filters
        handleSearchChange={handleSearchChange}
        handleSortChange={handleSortChange}
        handleDropdownChange={handleFilterChange}
        sortOptions={sortOptions}
        sortTitle="Filtrowanie:"
        placeholder="Wyszukaj wśród epizodów"
        variant={FiltersVariant.SortAndFilter}
        className={styles.filters}
      />

      {isEmpty && (
        <EmptyState
          className={styles.emptyState}
          subheading={searched ? "Spróbuj zmienić wpisaną frazę." : ""}
        />
      )}

      {elements.map((element, index) => {
        return (
          <PodcastTile
            key={index}
            {...element}
            className={styles.podcastTile}
          />
        );
      })}

      {isLoadingMore && <SkeletonLoader height={155} />}

      {!isReachingEnd && !isLoadingInitialData && (
        <Button
          variant="secondary"
          onClick={loadMore}
          className={styles.loadMore}
        >
          Pokaż więcej
        </Button>
      )}
    </>
  );
};

export default PodcastEpisodes;
